import React from 'react';

import { Typography } from '../atoms/typography';

type ImageWithCaptionProps = {
    caption?: string | null;
    className?: string;
    children: React.ReactNode;
};

export const ImageWithCaption = ({ children, caption, className }: ImageWithCaptionProps) => {
    if (!caption) {
        return <div className={className}>{children}</div>;
    }

    return (
        <figure className={className}>
            {children}
            {caption ? (
                <Typography variant="body-sm" as={'caption'} className="mt-2 text-neutral-700">
                    {caption}
                </Typography>
            ) : null}
        </figure>
    );
};
